<script>
    import { onMount } from "svelte";

    import LineChart from "../../../Components/Charts/LineChart.svelte";

    import GraphPeriodIndicator from "./GraphPeriodIndicator.svelte";

    import { getDataByPeriod } from "../helpers/GraphPeriodHelper.svelte";

    export let totalEncountersCreated = {},
        dateFrom,
        dateTo;

    let isParsingData = false;
    let chartData = [];
    let labelArr = [];

    let selectedPeriod = 0;

    onMount(() => {
        totalEncountersCreated && syncData();
    });

    const syncData = async () => {
        isParsingData = true;

        const topIndicatorName = `${selectedPeriod == 0 ? "Daily" : selectedPeriod == 1 ? "Weekly" : "Monthly"} total encounter created`;

        const { chartData: newChartData, labelArr: newLabelArr } =
            await getDataByPeriod(
                totalEncountersCreated,
                selectedPeriod,
                dateFrom,
                dateTo,
                topIndicatorName,
            );

        chartData = [...newChartData];
        labelArr = [...newLabelArr];

        isParsingData = false;
    };
</script>

<div class="flex flex-1 flex-col p-6">
    {#if isParsingData}
        <div class="flex flex-1 items-center text-center">
            Parsing chart data
        </div>
    {:else if !totalEncountersCreated}
        <div class="flex flex-1 items-center text-center">
            Noting to display
        </div>
    {:else}
        <div class="flex flex-1 items-center justify-end">
            <GraphPeriodIndicator
                bind:selectedPeriod
                onPeriodChange={syncData}
            />
        </div>

        <LineChart bind:chartData bind:labelArr />
    {/if}
</div>
